import { useId, useState } from 'react'
import Box from '@mui/material/Box'
import Close from '@mui/icons-material/Close'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import VoucherBenefits from 'components/VoucherBanner/components/VoucherBenefits'
import { VOUCHER_TERMS_URL } from 'components/VoucherBanner/VoucherBanner.constants'
import {
  ActivateButton,
  ActivatedRow,
  ActivatedText,
  Banner,
  Content,
  Header,
  HeaderContent
} from './RCEVariantBEditPageCollapsibleBanner.styles'

export interface RCEVariantBEditPageCollapsibleBannerProps {
  amount: number
  isActivated: boolean
  onActivate: () => void
  onTermsClick: () => void
}

const RCEVariantBEditPageCollapsibleBanner = ({
  amount,
  isActivated,
  onActivate,
  onTermsClick
}: RCEVariantBEditPageCollapsibleBannerProps) => {
  const [isExpanded, setIsExpanded] = useState(true)
  const contentId = useId()
  const toggleLabel = isExpanded ? 'Weniger anzeigen' : 'Mehr erfahren'

  return (
    <Banner aria-label="Gutscheinangebot">
      <Content>
        <Header>
          <HeaderContent>
            <Typography variant="h6" fontSize={16} fontWeight={700}>
              Kredit holen. {amount} € Gutschein sichern.
            </Typography>
            <Typography variant="body1" sx={{ ml: 1 }}>
              Jetzt bei smava.
            </Typography>
          </HeaderContent>
          <IconButton
            onClick={() => setIsExpanded((expanded) => !expanded)}
            aria-label={toggleLabel}
            aria-expanded={isExpanded}
            aria-controls={contentId}
            sx={{ color: 'inherit', padding: 0, margin: 0 }}
          >
            {isExpanded ? (
              <Close fontSize="small" />
            ) : (
              <InfoOutlined fontSize="small" />
            )}
          </IconButton>
        </Header>
        <Collapse in={isExpanded}>
          <Box
            id={contentId}
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            gap={2}
            mt={1}
          >
            <VoucherBenefits
              amount={amount}
              providerName="smava.de"
              termsUrl={VOUCHER_TERMS_URL.smava}
              onTermsClick={onTermsClick}
              variant="smava"
            />
            {isActivated ? (
              <ActivatedRow>
                <svg
                  width="22"
                  height="21"
                  viewBox="0 0 22 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0 20.54L14 15.54L5 6.54L0 20.54Z" fill="white" />
                  <path
                    d="M12.53 11.07L18.12 5.48C18.61 4.99 19.4 4.99 19.89 5.48L20.48 6.07L21.54 5.01L20.95 4.42C19.88 3.35 18.13 3.35 17.06 4.42L11.47 10.01L12.53 11.07Z"
                    fill="white"
                  />
                  <path
                    d="M8.06 5.42L7.47 6.01L8.53 7.07L9.12 6.48C10.19 5.41 10.19 3.66 9.12 2.59L8.53 2L7.47 3.07L8.06 3.66C8.54 4.14 8.54 4.94 8.06 5.42Z"
                    fill="white"
                  />
                  <path
                    d="M15.06 10.42L13.47 12.01L14.53 13.07L16.12 11.48C16.61 10.99 17.4 10.99 17.89 11.48L19.5 13.09L20.56 12.03L18.95 10.42C17.87 9.35 16.13 9.35 15.06 10.42Z"
                    fill="white"
                  />
                  <path
                    d="M13.06 4.42L9.47 8.01L10.53 9.07L14.12 5.48C15.19 4.41 15.19 2.66 14.12 1.59L12.53 0L11.47 1.06L13.06 2.65C13.54 3.14 13.54 3.94 13.06 4.42Z"
                    fill="white"
                  />
                </svg>

                <ActivatedText variant="body1">
                  Ihr {amount} € Gutschein ist aktiviert!
                </ActivatedText>
              </ActivatedRow>
            ) : (
              <ActivateButton
                variant="contained"
                size="small"
                onClick={onActivate}
              >
                Gutschein aktivieren
              </ActivateButton>
            )}
          </Box>
        </Collapse>
      </Content>
    </Banner>
  )
}

export default RCEVariantBEditPageCollapsibleBanner
